export const ANIMATED_UNDERLINED_BUTTON_TRANSITIONS_SPRING_PROPS = {
    from: {
        transform: 'translate3d(-100%, 0, 0)'
    },
    enter: {
        transform: 'translate3d(0, 0, 0)'
    },
    leave: {
        transform: 'translate3d(100%, 0, 0)'
    },
    unique: false
};
